<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_shipAdd" style="display: block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">배송지 관리</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont inTab">
        <ul class="tabHeader rew19_tab_pop nav nav-tabs nav-stacked">
          <li :class="{active:currentTab==1}"><a @click="currentTab=1;">배송지 선택</a></li>
          <li :class="{active:currentTab==2}"><a @click="currentTab=2;">신규 입력</a></li>
        </ul>
        <div class="tab-content rew19_tabCont">

          <transition name="fade">
            <div v-show="currentTab==1">
              <dl class="rew19_select_table ship">
                <dt>
                  <span class="rew19_table_tit">총 {{$fmt.PDCnt(viewData.deliveryList.length)}}개</span>
                </dt>
                <dd v-for="(item, idx) in viewData.deliveryList" :key="idx">
                  <ul class="rew19_table_form skinCare">
                    <li class="o1">
                      <div class="rew19_wrapRadio_t1">
                        <input :id="'deliveryList_'+idx" v-model="selectAddr" :value="item"
                          type="radio" class="rew19_fakeRadio_t1" >
                        <label :for="'deliveryList_'+idx"></label>
                      </div>
                    </li>
                    <li class="o2">
                      <em class="rew19_tit">{{item.shipName}}</em>
                      <span class="rew19_people">{{item.phoneNumber}}</span>
                      <p>(우 {{item.zipCode}}) {{item.firstAddress}} {{item.lastAddress}}</p>
                    </li>
                    <li class="o3">
                      <!--<span class="rew19_flagShip">최근 배송지</span>-->
                      <a @click="onClickEditAddress(item)" class="rew19_editShip">수정</a>
                      <a @click="onClickDeleteAddress(item)" class="rew19_delShip">삭제</a>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </transition>

          <transition name="fade">
            <div v-show="currentTab==2">
              <ul class="rew19_field_ul">
                <li>
                  <em>수령인</em>
                  <div class="rew19_filed_box">
                    <input
                      v-model.trim="viewData.editAddr.shipName"
                      ref="shipName"
                      maxlength="15"
                      type="text" class="rew19_inputTxt_t1" placeholder="한글명" title="수령인" >
                  </div>
                </li>
                <li>
                  <em>휴대폰 번호</em>
                  <div class="rew19_filed_box">
                    <input
                      v-model.trim="viewData.editAddr.phoneNumber"
                      ref="phoneNumber"
                      maxlength="11"
                      @keypress="numberKeyPress($event)"
                      @keyup="keyUpToNumber($event)"
                      type="text" style="ime-mode:disabled" class="rew19_inputTxt_t1" placeholder="숫자만 입력하세요" title="휴대폰 번호 입력">
                  </div>
                </li>
                <li>
                  <em>주소</em>
                  <div class="rew19_address_box">
                    <div class="address_btn_box">
                      <input
                        v-model.trim ="viewData.editAddr.zipCode"
                        ref="zipCode"
                        type="text" class="rew19_inputTxt_t1" placeholder="우편번호" title="우편번호를 입력하세요."
                        readonly="readonly">
                      <a @click="onClickFindAddress" class="rew19_btn_T1">검색</a>
                    </div>
                    <div class="rew19_address_inpt_box">
                      <input
                        v-model.trim="viewData.editAddr.firstAddress"
                        ref="firstAddress"
                        type="text" class="rew19_inputTxt_t1" placeholder="주소" title="주소를 입력하세요."
                        readonly="readonly">
                      <input
                        v-model.trim="viewData.editAddr.lastAddress"
                        ref="lastAddress"
                        maxlength="40"
                        type="text" class="rew19_inputTxt_t1" placeholder="상세주소" title="상세주소를 입력하세요.">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </transition>

        </div>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>

    <find-address-dialog
      :show="findAddressDialogShow"
      @setData="setShipInfo"
      ref="findAddressDialog"
    ></find-address-dialog>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import FindAddressDialog from '@/components/popup/FindAddressDialog';

export default {
  name: 'ShipInfoDialog',
  components: { FindAddressDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTab : 1, //1:배송지 선택, 2:신규입력,
      currentZIndex : 2000,

      memberId : null,

      //View Data
      viewData : {
        deliveryList : [
          // {
          // addr1: null,
          // addr2: null,
          // addr3: null,
          // firstAddress: null,
          // lastAddress: null,
          // phoneNumber: null,
          // recNo: null,
          // region: null,
          // shipName: null,
          // zipCode: null,
          // }
        ],
        editAddr : {
          // addr1: null,
          // addr2: null,
          // addr3: null,
          // firstAddress: null,
          // lastAddress: null,
          // phoneNumber: null,
          // recNo: null,
          // region: null,
          // shipName: null,
          // zipCode: null,
        }
      },

      //resData
      selectAddr : null,

      //Find Address Dialog
      findAddressDialogShow : false,
      findAddressDialog : {

      },
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;
  },
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.selectAddr : null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(!_this.selectAddr){
        if(_this.currentTab == 1){
          _this.$dialogs.alert("배송지 목록을 선택해 주십시오.")
          .then(res => {});
          return;
        }else if(_this.currentTab == 2){
          //validation
          if(!_this.validateAddress()){
            return;
          }

          _this.selectAddr = {..._this.viewData.editAddr};

          //add 배송지 목록

          //show loading
          _this.$showLoading();
          _this.apiPutDeliveryAddress(_this.selectAddr).then(res=>{

            let isSuccess = false;
            if(res.status === 200){
              res.data = JSON.parse(_this.$parseNuskinApiRes(res.data));

              if(res.data.result === "1") {
                _this.onClose(true);
                isSuccess = true;
              }
            }

            if(!isSuccess){
              //console.error(res);
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              throw errMsg;
            }

          }).catch((err)=>{
            console.error(err);
            _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

          }).finally(()=>{
            //hide loading
            _this.$hideLoading();
          });

          return;
        }
      }else{
        if(_this.currentTab == 1){
          _this.viewData.editAddr = {..._this.selectAddr};
        }else{
          _this.selectAddr = {..._this.viewData.editAddr};
        }
        //validation
        if(!_this.validateAddress()){
          return;
        }
      }
      _this.onClose(true);
    },

    /**
     * API Request
     */
    //배송지 주소 가져오기
    apiGetDeliveryAddress : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_delivery_address`, {
        params: {
          memberId : _this.memberId
        }
      });
    },

    //배송지 등록
    apiPutDeliveryAddress : function(addrInfo){
      let _this = this;

      let mp = {
        mobilecd : addrInfo.phoneNumber.substring(0, 3),
        mobile1 : "",
        mobile2 : "",
      };
      {
        let tempPh = addrInfo.phoneNumber.substring(3);
        mp.mobile2 = tempPh.substring(tempPh.length-4);
        mp.mobile1 = tempPh.substring(0, tempPh.length-4);
      }

      let params = {
        ...addrInfo,
        memberId : _this.memberId,
        addr4 : addrInfo.lastAddress,
        ...mp
      };

      if(addrInfo.recNo && !isNaN(addrInfo.recNo)){
        params.isUpdate = "Y";
      }

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_delivery_address`, {
        params: params
      });
    },

    //배송지 삭제
    apiDeleteDeliveryAddress : function(addrInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/delete_delivery_address`, {
        params: {
          memberId : _this.memberId,
          recNo : addrInfo.recNo,
        }
      });
    },

    /**
     * Local
     */
    initData : function(paramData){
      let _this = this;

      _this.selectAddr = null;
      _this.memberId = paramData.memberId;
      _this.loadData();
    },

    loadData : function(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetDeliveryAddress().then(res=>{

        let isSuccess = false;
        if(res.status === 200){
          res.data = JSON.parse(_this.$parseNuskinApiRes(res.data));

          if(res.data.result === "1") {
            isSuccess = true;
            _this.viewData.deliveryList = [];
            res.data.deliveryAddrList.forEach(element => {
              _this.viewData.deliveryList.push(element);
            });
          }
        }

        if(!isSuccess){
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          throw errMsg;
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //기존 배송지 수정
    onClickEditAddress(addrInfo){
      let _this = this;
      _this.viewData.editAddr = {phoneNumber : "", ...addrInfo};
      _this.viewData.editAddr.phoneNumber = _this.viewData.editAddr.phoneNumber.replace(/-/g,'');
      _this.currentTab = 2;
    },

    //기존 배송지 삭제
    onClickDeleteAddress(addrInfo){
      let _this = this;
      let msg = `선택하신 배송지를 삭제 하시겠습니까?`;

      _this.$dialogs.confirm(msg, {cancelLabel: '취소', okLabel:'확인'}).then(res=>{
        if(res.ok){
          _this.doDeleteAddress(addrInfo);
        }
      });
    },

    //기존 배송지 삭제 처리
    doDeleteAddress(addrInfo){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiDeleteDeliveryAddress(addrInfo).then(res=>{

        let isSuccess = false;
        if(res.status === 200){
          res.data = JSON.parse(_this.$parseNuskinApiRes(res.data));

          if(res.data.result === "1") {
            isSuccess = true;
          }
        }

        if(!isSuccess){
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          throw errMsg;
        }else{
          _this.viewData.deliveryList = _this.viewData.deliveryList.filter(item=>{
            return item.recNo != addrInfo.recNo;
          })
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //우편번호 찾기
    onClickFindAddress(){
      let _this = this;

      //pass data to dialog
      let dialogData = _this.findAddressDialog;

      _this.$refs.findAddressDialog.initData(dialogData);
      _this.findAddressDialogShow = true;
    },

    setShipInfo(isOk, data){
      let _this = this;

      _this.findAddressDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.viewData.editAddr = {
        ..._this.viewData.editAddr,
        addr1: data.sido_ko,
        addr2: data.sigungu_ko,
        addr3: data.ko_doro_dongri,
        firstAddress: `${data.sido_ko} ${data.sigungu_ko} ${data.ko_doro_dongri}`,
        region: data.region,
        zipCode: data.postcode5,
      };
    },

    validateAddress(){
      let _this = this;

      let addrInfo = _this.viewData.editAddr;
      let regText = /^[0-9A-Za-z가-힣ㄱ-ㅎ-ㅏ-ㅣ\.,-\\\()/@#\+\s]*$/g;

      let chVal = addrInfo.shipName;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("수령인을 입력해 주십시오.")
        .then(res => {
          _this.$refs.shipName.focus();
        });
        return false;
      }

      if(!regText.test(chVal)){
        _this.$dialogs.alert("수령인은 특수문자를 사용할 수 없습니다.");
        return false;
      }

      if(chVal.length > 15){
        _this.$dialogs.alert("수령인을 15자리 이내로 입력해 주십시오.")
        .then(res => {
          _this.$refs.shipName.focus();
        });
        return false;
      }

      chVal = addrInfo.phoneNumber.replace(/-/gi,'');
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("휴대폰 번호를 입력해 주십시오.")
        .then(res => {
          _this.$refs.phoneNumber.focus();
        });
        return false;
      }

      if(chVal.length < 10){
        _this.$dialogs.alert("휴대폰 번호를 확인해 주십시오.")
        .then(res => {
          _this.$refs.phoneNumber.focus();
        });
        return false;
      }

      if(chVal.length > 11){
        _this.$dialogs.alert("휴대폰 번호를 11자리 이내로 입력해 주십시오.")
        .then(res => {
          _this.$refs.phoneNumber.focus();
        });
        return false;
      }

      chVal = addrInfo.zipCode;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("우편번호를 선택해 주십시오.")
        .then(res => {
          _this.$refs.zipCode.focus();
        });
        return false;
      }

      chVal = addrInfo.lastAddress;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("상세주소를 입력해 주십시오.")
        .then(res => {
          _this.$refs.lastAddress.focus();
        });
        return false;
      }

      if(chVal.length > 40){
        _this.$dialogs.alert("상세주소를 40자리 이내로 입력해 주십시오.")
        .then(res => {
          _this.$refs.lastAddress.focus();
        });
        return false;
      }

      regText = /^[0-9A-Za-z가-힣ㄱ-ㅎ-ㅏ-ㅣ\.,-\\\()/@#\+\s]*$/g;
      if(!regText.test(chVal)){
        _this.$dialogs.alert("상세주소는 특수문자를 사용할 수 없습니다.").then(res => {
          _this.$refs.lastAddress.focus();
        });
        return false;
      }

      return true;
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },
  }
}
</script>
<style>
ul.tabHeader li a{
  cursor: pointer;
}

li.o3 a {
  cursor: pointer;
}

.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ShipInfoDialog.vue